module.exports = __webpack_public_path__ + "static/img/withdraw.630e63a6.png";